import { RouteRecordRaw } from 'vue-router'

import ViewErgebnisliste from '@/views/ergebnisliste/ViewErgebnisliste.vue'
import ViewCounselingCenter from '@/views/ergebnisliste/ViewCounselingCenter.vue';
import ViewLegalEntity from '@/views/ergebnisliste/ViewLegalEntity.vue'


const routesWidgetErgebnisliste: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'widget-ergebnisliste',
    component: ViewErgebnisliste
  },
  {
    path: '/legal-entities/:leid',
    name: 'legal-entities',
    component: ViewLegalEntity,
    props: { default: true }
  },
  {
    path: '/counseling-center/:ccid',
    name: 'counseling-center',
    component: ViewCounselingCenter,
    props: { default: true }
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: to => {
      // the function receives the target route as the argument
      // we return a redirect path/location here.
      if (to.path == "/main" || to.path == "/navDesk") {
        return {
          path: '/',
          hash: to.path.substring(1)
        }
      } else {
        return {
          path: '/'
        }
      }

    },
  }
]

export default routesWidgetErgebnisliste
